import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

type SpecialityCardProps = {
  name: string;
  path?: string;
  imageUrl: string;
};

export default function ServiceCard({
  name,
  path = '#',
  imageUrl,
}: SpecialityCardProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Card raised sx={{ p: { xs: 1, sm: 3 }, minHeight: { xs: 'auto', sm: '318px' } }}>
      <Box sx={{ overflow: 'auto' }}>
        <CardMedia
          component="img"
          image={imageUrl}
          alt="Lawyer Icon"
          draggable={false}
          sx={{ width: '150px', height: '150px', m: '0 auto 24px auto' }}
        />

        <Typography variant="h6" align="center" sx={{ textTransform: 'uppercase' }}>
          <Link
            component={RouterLink}
            to={path}
            underline="hover"
            sx={{ textDecoration: 'unset' }}
          >
            {t(name)}
          </Link>
        </Typography>
      </Box>
    </Card>
  );
}
